/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const HeliportSize = zod
  .object({
    size: zod.string(),
    shape: zod.enum(["OCTAGONAL", "RECTANGULAR", "IRREGULAR"]),
  })
  .describe("Opaque size text; no geometry parser or bounds.");

export type HeliportSize = zod.input<typeof HeliportSize>;
export type HeliportSizeOutput = zod.output<typeof HeliportSize>;
